import makeStyles from '@mui/styles/makeStyles';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import withStyles from '@mui/styles/withStyles';

const AccordionSummary = withStyles({
  root: {
    minHeight: 0,
    padding: 0,
    '&$expanded': {
      minHeight: 0,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: '0',
  },
})(MuiAccordionDetails);

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: '14px',
    color: '#2789c0',
    fontFamily: 'Inter600',
  },

  accordion: {
    boxShadow: 'none',
    borderTop: '1px solid #d9d9d9;',
    borderRadius: '0 !important',
    margin: '0 !important',
    '&::before': {
      content: 'none',
    },
  },
}));

export { AccordionSummary, AccordionDetails, useStyles };
